import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { useStyleStore } from "@vcl";

export default class CountColor extends BaseOption {
  static userInterfaceComponent = {
    label: "Count Color",
    component: inspectorTools.COLOR_PICKER,
    canSetOtherStates: [BaseOption.$states.HOVER],
    props: {
      width: "fill",
      colorContext: "Fonts",
    },
  };

  static defaultValue = {
    value: "standard",
    source: "theme.font",
  };

  static deprecatedFontColorAliases = [
    "light",
    "informational",
    "disabled",
    "warning",
  ];

  static convertConfigValueToCompiledValue(configValue, themeId, themeMode = "inherit") {
    const styleStore = useStyleStore();
    let palette = styleStore.themePalettes[themeId];

    if (configValue.source.includes("semantic")) {
      palette = styleStore.getSemanticPaletteFromMode(themeId, themeMode);
    }
    return BaseOption.getColorValue(configValue, styleStore.themes[themeId], palette, themeId, themeMode);
  }

  static convertValueToStringForTransactionLog(compiledValue) {
    return compiledValue.value;
  }
}
